export const DOWNLOAD_ATTACHMENT_STATUS = {
  NOT_REQUESTED: 'NOT_REQUESTED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  NO_ATTACHMENT: 'NO_ATTACHMENT',
}

export const DOWNLOAD_ATTACHMENT_STATUS_CONFIG = {
  [DOWNLOAD_ATTACHMENT_STATUS.NOT_REQUESTED]: {
    label: 'fleetTask.downloadPhoto.status.pending',
    color: 'secondary',
  },
  [DOWNLOAD_ATTACHMENT_STATUS.IN_PROGRESS]: {
    label: 'fleetTask.downloadPhoto.status.processing',
    color: 'warning',
  },
  [DOWNLOAD_ATTACHMENT_STATUS.SUCCESS]: {
    label: 'fleetTask.downloadPhoto.status.success',
    color: 'success',
  },
  [DOWNLOAD_ATTACHMENT_STATUS.FAILED]: {
    label: 'fleetTask.downloadPhoto.status.failed',
    color: 'danger',
  },
  [DOWNLOAD_ATTACHMENT_STATUS.NO_ATTACHMENT]: {
    label: 'fleetTask.downloadPhoto.status.empty',
    color: 'secondary',
  },
}
export const DOWNLOAD_ATTACHMENT_ACTION_CONFIG = {
  [DOWNLOAD_ATTACHMENT_STATUS.NOT_REQUESTED]: {
    label: 'fleetTask.downloadPhoto.action.prepare',
    icon: 'icon-outline_archive',
  },
  [DOWNLOAD_ATTACHMENT_STATUS.IN_PROGRESS]: {
    label: 'fleetTask.downloadPhoto.action.processing',
    icon: '',
  },
  [DOWNLOAD_ATTACHMENT_STATUS.SUCCESS]: {
    label: 'fleetTask.downloadPhoto.action.download',
    icon: 'icon-fill_download',
  },
  [DOWNLOAD_ATTACHMENT_STATUS.FAILED]: {
    label: 'fleetTask.downloadPhoto.action.retry',
    icon: 'icon-fill_refresh',
  },
  [DOWNLOAD_ATTACHMENT_STATUS.NO_ATTACHMENT]: {
    label: 'fleetTask.downloadPhoto.action.prepare',
    icon: 'icon-fill_archive',
  },
}

export const DISABLED_ACTION_KEYS = [
  DOWNLOAD_ATTACHMENT_STATUS.IN_PROGRESS,
  DOWNLOAD_ATTACHMENT_STATUS.NO_ATTACHMENT,
]

export const ATTACHMENT_TYPE = {
  POP: 'PICKUP',
  POD: 'DROP',
}

export const ATTACHMENT_ACTIVITY_TYPE = {
  POP: 'PICKUP',
  POD: 'DROP',
}
